export default "/_next/static/images/328708f7d63a9419a8b2163a1f4c4015.png";